import React, { useState, useEffect } from "react";
import { IonAvatar } from "@ionic/react";
import { Location } from "../../@types/location";
import api from "../../utils/api";

export const LocationAvatar: React.FC<{ location?: Location }> = ({ location = {} }) => {
  const [avatarSrc, setAvatarSrc] = useState('https://programacion.net/files/article/20161110041116_image-not-found.png');

  useEffect(() => {
    const fetchAvatar = async () => {
      if (location?.picture) {
        try {
          const token = localStorage.getItem('token');
          const pictureId = location.picture?.id || location.picture;
          const response = await fetch(`${api.baseURL}archive/${pictureId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setAvatarSrc(url);
          } else {
            console.error('Error fetching avatar:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchAvatar();
  }, [location]);

  return (
    <IonAvatar slot="start">
      <img
        src={avatarSrc}
        alt="Location Avatar"
        width="60"
        height="60"
      />
    </IonAvatar>
  );
};